module.exports = __webpack_public_path__ + "static/media/2.e7548f97.jpg";